import { useRef, useEffect } from 'react';

const FJTextWithEllipsisChildren = ({ style, className, onClick = () => {}, isRender = true, title, children }) => {
    const textRef = useRef(null);

    useEffect(() => {
        const container = textRef.current;
        if (container.scrollWidth > container.offsetWidth) {
            container.setAttribute('title', title);
        } else {
            container.removeAttribute('title');
        }
    }, [isRender, title]);

    return (
        <div
            ref={textRef}
            style={{
                overflow: 'hidden', // 隐藏溢出的文本
                textOverflow: 'ellipsis', // 显示省略号
                whiteSpace: 'nowrap', // 防止文本换行
                ...style,
            }}
            className={className}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

export default FJTextWithEllipsisChildren;
